// @spec GHG-STR-102
/**
 * API client functions for GHG activity group endpoints.
 */

import { createApiClient } from '@/lib/api-client';

export interface ActivityGroup {
  id: string;
  organizationId: string;
  name: string;
  code?: string | null;
  description?: string | null;
  facilityId?: string | null;
  scopeHint?: 1 | 2 | 3 | null;
  scope3CategoryHint?: number | null;
  status: 'active' | 'inactive';
  createdAt: string;
  updatedAt: string;
}

export interface ActivityGroupListResponse {
  items: ActivityGroup[];
  total: number;
}

export interface CreateActivityGroupInput {
  name: string;
  code?: string | undefined;
  description?: string | undefined;
  facilityId?: string | undefined;
  scopeHint?: 1 | 2 | 3 | undefined;
  scope3CategoryHint?: number | undefined;
  status?: 'active' | 'inactive' | undefined;
}

export interface UpdateActivityGroupInput {
  name?: string | undefined;
  code?: string | undefined;
  description?: string | undefined;
  facilityId?: string | undefined;
  scopeHint?: 1 | 2 | 3 | undefined;
  scope3CategoryHint?: number | undefined;
  status?: 'active' | 'inactive' | undefined;
}

export async function fetchActivityGroups(
  getToken: () => Promise<string | null>,
  organizationId: string
): Promise<ActivityGroupListResponse> {
  const apiClient = createApiClient({ getAuthToken: getToken });
  return apiClient.get<ActivityGroupListResponse>(
    `/organizations/${organizationId}/ghg/activity-groups`
  );
}

export async function createActivityGroup(
  getToken: () => Promise<string | null>,
  organizationId: string,
  data: CreateActivityGroupInput
): Promise<ActivityGroup> {
  const apiClient = createApiClient({ getAuthToken: getToken });
  return apiClient.post<ActivityGroup>(
    `/organizations/${organizationId}/ghg/activity-groups`,
    data
  );
}

export async function updateActivityGroup(
  getToken: () => Promise<string | null>,
  organizationId: string,
  groupId: string,
  data: UpdateActivityGroupInput
): Promise<ActivityGroup> {
  const apiClient = createApiClient({ getAuthToken: getToken });
  return apiClient.patch<ActivityGroup>(
    `/organizations/${organizationId}/ghg/activity-groups/${groupId}`,
    data
  );
}

export async function deleteActivityGroup(
  getToken: () => Promise<string | null>,
  organizationId: string,
  groupId: string
): Promise<void> {
  const apiClient = createApiClient({ getAuthToken: getToken });
  await apiClient.delete(`/organizations/${organizationId}/ghg/activity-groups/${groupId}`);
}

